import { ACTION } from './buildings_actions';
import {
  list_reducer,
  add_reducer,
  update_reducer,
  delete_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  loading: false,
  editing: false,
  creating: false,
  uploading: false,
  exporting: false,
  reportUrl: null,
  errorMessage: null,
};

export default (state = initialState, action) => {

  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        loading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        loading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        editing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        editing: false,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        editing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        creating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        creating: false,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        creating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        deleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        deleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        deleting: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EXPORT_REPORT}_PENDING`:
      return {
        ...state,
        exporting: true,
        errorMessage: null,
      };
    case `${ACTION.EXPORT_REPORT}_FULFILLED`:
      return {
        ...state,
        reportUrl: action.payload.link,
        exporting: false,
      };
    case `${ACTION.EXPORT_REPORT}_REJECTED`:
      return {
        ...state,
        exporting: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/buildings/buildings_reducers.js